import React from 'react';
import Parallax from '.';

function Background(props) {
    return (
        <div className="background_parallax">
            <Parallax id={"box1"} top={"500px"} left={"50%"} rotate={"378deg"} factor={0.85} width={"620px"} height={"423px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box2"} top={"1000px"} left={"5%"} rotate={"48deg"} factor={0.7} width={"620px"} height={"583px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box3"} top={"1400px"} left={"80%"} rotate={"267deg"} factor={0.6} width={"545px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box4"} top={"200px"} left={"10%"} rotate={"98deg"} factor={0.75} width={"534px"} height={"643px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box5"} top={"700px"} left={"40%"} rotate={"123deg"} factor={0.6} width={"532px"} height={"639px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box6"} top={"1800px"} left={"90%"} rotate={"2347deg"} factor={0.9} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box7"} top={"1900px"} left={"10%"} rotate={"27deg"} factor={0.6} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box8"} top={"2000px"} left={"0%"} rotate={"543deg"} factor={0.7} width={"523px"} height={"435px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box9"} top={"2200px"} left={"-60%"} rotate={"85deg"} factor={0.6} width={"634px"} height={"234px"}>
                <div className="box"></div>
            </Parallax>

            <Parallax id={"box10"} top={"2500px"} left={"50%"} rotate={"378deg"} factor={0.85} width={"620px"} height={"423px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box11"} top={"3000px"} left={"5%"} rotate={"48deg"} factor={0.7} width={"620px"} height={"583px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box12"} top={"3400px"} left={"80%"} rotate={"267deg"} factor={0.6} width={"545px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box13"} top={"2200px"} left={"10%"} rotate={"98deg"} factor={0.75} width={"534px"} height={"643px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box14"} top={"2700px"} left={"40%"} rotate={"123deg"} factor={0.6} width={"532px"} height={"639px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box15"} top={"3800px"} left={"90%"} rotate={"2347deg"} factor={0.9} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box16"} top={"3900px"} left={"10%"} rotate={"27deg"} factor={0.6} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box17"} top={"4000px"} left={"0%"} rotate={"543deg"} factor={0.7} width={"523px"} height={"435px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"box18"} top={"4200px"} left={"-60%"} rotate={"85deg"} factor={0.6} width={"634px"} height={"234px"}>
                <div className="box"></div>
            </Parallax>
        </div>
    );
}

export default Background;